var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M3.705 10.994l7.31 7.31c.298.4.225.966-.165 1.279-.145.171-.353.276-.577.288-.224.013-.443-.067-.605-.22l-7.312-7.31 1.349-1.347z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M3.417 13.379l7.656-7.656c.299-.401.226-.967-.165-1.28-.144-.171-.353-.276-.576-.288-.224-.013-.443.067-.606.221L2.07 12.032l1.347 1.347z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E4E4E",
    d: "M4.367 12.883h16.81c.238-.008.462-.116.617-.297.155-.18.228-.418.2-.655.02-.483-.337-.9-.817-.953H4.367v1.905z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.db9b3fc73c924317d6fac0289dab6b2f.svg";
export { ForwardRef as ReactComponent };